export const hasReach = (el, callback) => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => callback(entry.isIntersecting));
    });
    observer.observe(el);
    return observer;
};
